"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.toolDef = void 0;
exports.handle = handle;
const fs = __importStar(require("fs-extra"));
const dist_1 = require("../../../fs/dist");
const req_1 = require("../../../app/dist/req");
exports.toolDef = {
    name: 'loom_amend_req',
    description: "Amend a thread's req under append-only rules: reconcile new/changed requirements into the spec, re-open it to \"draft\", and bump the version (a bump marks downstream idea/design/plan stale). Requirement handles (`IN`/`EX`/`C`) are immutable citation targets — this tool **refuses** any body that deletes or renumbers an existing handle. Append fresh handles for new scope; retire an obsolete one by marking it `~dropped` (which keeps the handle present and citation-resolvable), never by deleting it. Use this tool to edit an existing req — do not edit weave files directly.",
    inputSchema: {
        type: 'object',
        properties: {
            weave_slug: { type: 'string', description: 'Target weave folder slug' },
            thread_ulid: { type: 'string', description: 'Stable th_ ULID of the thread inside the weave' },
            content: { type: 'string', description: 'New markdown body (append-only on handles). Omit to leave the body unchanged (a pure re-open).' },
        },
        required: ['weave_slug', 'thread_ulid'],
    },
};
async function handle(root, args) {
    try {
        const result = await (0, req_1.amendReq)({
            weaveSlug: args['weave_slug'],
            threadUlid: args['thread_ulid'],
            content: args['content'],
        }, { getActiveLoomRoot: () => (0, dist_1.getActiveLoomRoot)(root), saveDoc: dist_1.saveDoc, loadDoc: dist_1.loadDoc, fs });
        return { content: [{ type: 'text', text: JSON.stringify(result) }] };
    }
    catch (e) {
        // Surface a handle-integrity violation as a clean finding, not a crash.
        const message = e instanceof Error ? e.message : String(e);
        return { content: [{ type: 'text', text: JSON.stringify({ ok: false, error: message }) }] };
    }
}
